'use strict';

exports.__esModule = true;
exports.get = get;
exports.getRawValue = getRawValue;
function get(object) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var result = getRawValue(object, property);
  if (typeof result === 'undefined') {
    return '';
  }
  if (result === null) {
    return '';
  }
  return '' + result;
}

function getRawValue(object) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return property.split('.').reduce(function (acc, curr) {
    return acc ? acc[curr] : undefined;
  }, object);
}